import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import generateID from '@/utilities/generateID';
import JSONReader from '@/components/JSONReader.vue';
import baseCharacter from '@/modules/CharacterEngine/baseCharacter.json';
import Loading from '@/components/Loading.vue';
import SignInButton from '@/components/SignInButton.vue';
const characterModule = namespace('character');
const authenticationModule = namespace('authentication');
let MyCharacters = class MyCharacters extends Vue {
    constructor() {
        super(...arguments);
        this.searchText = '';
        this.isFabOpen = false;
        this.isImportOpen = false;
        this.characterLimit = process.env.VUE_APP_characterLimitPerUser;
        this.isLoadingCharacter = true;
    }
    created() {
        this.fetchCharacters().then(() => {
            this.saveCharactersWithoutIds();
            this.isLoadingCharacter = false;
        });
    }
    saveTempCharacters() {
        this.fetchCharacters().then(() => {
            this.saveCharactersWithoutIds();
        });
    }
    get isOverCharacterLimit() {
        return this.characters.length >= this.characterLimit;
    }
    get filteredCharacters() {
        return this.characters
            .filter(({ name }) => (name && name.toLowerCase() ? name.toLowerCase() : 'unnamed character').includes(this.searchText.toLowerCase()))
            .sort((char1, char2) => char1.changedAt && (char1.changedAt < char2.changedAt) ? 1 : -1);
    }
    saveCharactersWithoutIds() {
        if (this.isLoggedIn) {
            this.saveCharacters(this.characters.filter(({ id }) => !id));
        }
    }
    getClassText(character) {
        const { species, classes } = character;
        return species.name || classes.length
            ? species.name + ' ' + classes
                .map(({ name, levels, archetype }) => `${name}${archetype && classes.length < 3 ? ` (${archetype.name})` : ''} ${levels}`)
                .join(', ')
            : 'No species or classes chosen.';
    }
    handleCreateCharacter(newCharacter) {
        const localId = 'temp-' + generateID();
        this.isLoadingCharacter = true;
        if (newCharacter) {
            // Save a character after importing
            this.saveCharacter({
                ...baseCharacter,
                ...newCharacter,
                createdAt: newCharacter.createdAt ? newCharacter.createdAt : Date.now(),
                localId
            })
                .then(() => this.$router.push('mycharacters/' + encodeURIComponent(localId) + '?isNew=true'))
                .finally(() => { this.isLoadingCharacter = false; });
        }
        else {
            // Don't save a new, empty character
            this.saveCharacterLocally({
                ...baseCharacter,
                createdAt: Date.now(),
                localId
            })
                .then(() => this.$router.push('mycharacters/' + encodeURIComponent(localId) + '?isNew=true'))
                .finally(() => { this.isLoadingCharacter = false; });
        }
    }
};
__decorate([
    authenticationModule.Getter
], MyCharacters.prototype, "isLoggedIn", void 0);
__decorate([
    characterModule.State
], MyCharacters.prototype, "characters", void 0);
__decorate([
    characterModule.Action
], MyCharacters.prototype, "fetchCharacters", void 0);
__decorate([
    characterModule.Action
], MyCharacters.prototype, "saveCharacter", void 0);
__decorate([
    characterModule.Action
], MyCharacters.prototype, "saveCharacters", void 0);
__decorate([
    characterModule.Action
], MyCharacters.prototype, "saveCharacterLocally", void 0);
__decorate([
    Watch('isLoggedIn')
], MyCharacters.prototype, "saveTempCharacters", null);
MyCharacters = __decorate([
    Component({
        components: {
            JSONReader,
            SignInButton,
            Loading
        }
    })
], MyCharacters);
export default MyCharacters;
